/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import Spinner from "../loaders/Spinner";

/**
 * Internal dependencies
 */
import config from "../config";
const { texts } = config || {};

const LoadMore = ({ isVisible, isLoading, onClick }) => {
	if (!isVisible) {
		return null;
	}

	if (isLoading) {
		return <Spinner />;
	}

	return (
		<div className="wp-block-button is-style-fill" onClick={onClick}>
			<span className="wp-block-button__link has-burgundy-background-color has-background wp-element-button">{texts?.load_more}</span>
		</div>
	);
};

export default LoadMore;
